import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FactorModel } from 'src/app/models/factor.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-factor-modal',
    templateUrl: './factor-modal.component.html',
    styleUrls: ['./factor-modal.component.scss'],
    imports: [FormsModule]
})
export class FactorModalComponent {
  toastr = inject(ToastService);
  factorSvc = inject(SupplierService);


  @Output() reloadPage = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();
  @Input() selectedFactor?: FactorModel;
  newFactor!: FactorModel;

  name: string = '';
  weight: number | null = null;
  points: number | null = null;
  isActive: boolean = true;

  ngOnInit() {
    if (this.selectedFactor) {
      this.name = this.selectedFactor.name;
      this.weight = this.selectedFactor.weight;
      this.points = this.selectedFactor.points;
      this.isActive = this.selectedFactor.isActive;
    }
  }

  onSubmit() {
    if (!this.selectedFactor) {
      if (this.validateForm()) {
        this.factorSvc.postFactor(this.newFactor).subscribe({
          next: (result) => {
            this.toastr.success(
              'Factor registrado',
              'El factor ' +
                this.newFactor.name +
                ' se ha registrado correctamente.'
            );
            this.clearForm();
          },
          error: (err) => {
            this.toastr.error(
              'Error',
              'No se pudo registrar el factor. Todos los campos son obligatorios' +
                err.error.error
            );
          },
        });
      }
    } else {
      if (this.validateForm() && this.weight != null && this.points != null) {
        this.selectedFactor = {
          id: this.selectedFactor.id,
          name: this.name,
          weight: this.weight,
          points: this.points,
          isActive: this.isActive,
        };
        this.factorSvc
          .patchFactor(this.selectedFactor.id, this.selectedFactor)
          .subscribe({
            next: (result) => {
              this.toastr.success(
                'Factor editado',
                'El factor ' +
                  this.newFactor.name +
                  ' se ha editado correctamente.'
              );
              this.clearForm();
            },
            error: (err) => {
              this.toastr.error(
                'Error',
                'No se pudo editar el factor.' + err.error
              );
            },
          });
      }
    }
  }

  validateForm() {
    if (
      this.name != '' &&
      this.weight != 0 &&
      this.points != 0 &&
      this.weight != null &&
      this.points != null
    ) {
      this.newFactor = {
        id: '',
        name: this.name,
        weight: this.weight,
        points: this.points,
        isActive: this.isActive,
      };
      return true;
    } else {
      this.toastr.error(
        'Error',
        'No se pudo registrar el factor. Todos los campos son obligatorios.'
      );
      return false;
    }
  }

  clearForm() {
    this.name = '';
    this.weight = 0;
    this.points = 0;
    this.cancelClick();
  }

  cancelClick() {
    this.closeModal.emit();
    this.reloadPage.emit();
  }

  validateOnlyNumbers(event: KeyboardEvent) {
    let key = event.key;
    if (['.', 'e', 'E', ',', '-', '+'].includes(key)) {
      event.preventDefault();
    }
  }
  validateSpecialCharacters(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    input.value = value.replaceAll(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
  }
  validateWeigth(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length > 3) {
      input.value = value.slice(0, 3);
    }
  }

  validatePoints(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length > 8) {
      input.value = value.slice(0, 8);
    }
  }

}
